module.exports = __webpack_public_path__ + "img/tti.6a0e271b.png";